import { PreferredLocale } from '../constants/cookies';
import Global from '../store/global-selectors';
import { getPreferredLocaleFromUserSetting } from './get-intl';

// Lives in its own module (separate from get-intl) BECAUSE it imports the global-selectors barrel,
// which transitively pulls in the entire Redux store. get-intl is imported by intl-provider/hooks on
// the unauthenticated auth pages (login, etc.) — pages that have NO Redux — so keeping this
// store-dependent selector here prevents those pages from statically pulling the whole store graph.
export const getPreferredLocale = (state) => {
  const userSettingPreferredLocale = Global.selectUserUserSetting(state, {
    userSetting: PreferredLocale,
  });
  return getPreferredLocaleFromUserSetting(userSettingPreferredLocale);
};
